<template>
  <div class="currency-switcher-wrapper">
    <slot v-bind="bindings" />
    <transition name="slide-right">
      <currency-sidebar
        v-if="isActive"
        :outer-activator="activator"
        :show-back-btn="showBackBtn"
        :base-currency="baseCurrency"
        @close="deactivate"
      />
    </transition>
    <transition name="fade">
      <div
        v-if="isActive"
        class="backlight"
        @click="deactivate"
      />
    </transition>
  </div>
</template>

<script>
  import { mapActions, mapGetters, mapState } from 'vuex'
  import CurrencySidebar from './components/currency-sidebar.vue'

  export default {
    name: 'CurrencySwitcher',
    components: {
      CurrencySidebar
    },
    props: {
      showBackBtn: {
        type: Boolean,
        default: false
      },
      baseCurrency: {
        type: String
      }
    },
    data: () => ({
      isActive: false,
      activator: null
    }),
    computed: {
      ...mapState('currency', ['currencyRatePending', 'selectedCurrency']),
      bindings() {
        return {
          isActive: this.isActive,
          activate: this.activate,
          deactivate: this.deactivate,
        }
      }
    },
    watch: {
      isActive(val) {
        if (!val) {
          this.clearRateErrors()
        }
      },
      selectedCurrency(val) {
        if (val) {
          setTimeout(() => {
            this.deactivate()
          }, 1000)
        }
      },
    },
    methods: {
      ...mapActions('currency', ['clearRateErrors']),
      activate(e) {
        this.activator = e.target
        this.isActive = true
      },
      deactivate() {
        this.isActive = false
        this.$emit('close')
        this.$nextTick(() => {
          this.activator = null
        })
      }
    }
  }
</script>
